import VisibilityOff from "@material-symbols/svg-500/rounded/visibility_off.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const VisibilityOffIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: VisibilityOff });
	return <Icon />;
};

export default memo(VisibilityOffIcon);
